module.exports = {
  "m-r-24": {
    "marginRight": "24"
  },
  "m-r-0": {
    "marginRight": "0"
  },
  "wrap": {
    "height": "68",
    "borderRadius": "34",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "overflow": "hidden",
    "paddingLeft": "32",
    "paddingRight": "32",
    "maxWidth": "592"
  },
  "wrap2": {
    "height": "68"
  },
  "content": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center",
    "overflow": "hidden",
    "maxWidth": "528",
    "flex": 1
  },
  "main": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "dot": {
    "width": "14",
    "height": "14",
    "marginRight": "16",
    "borderRadius": "14"
  },
  "mainText": {
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "28",
    "fontWeight": "500"
  },
  "fakeBorder": {
    "width": "2",
    "height": "40",
    "backgroundColor": "rgba(0,0,0,0)"
  },
  "promptBox": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "prompt": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "promptText": {
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "28",
    "fontWeight": "500"
  },
  "smallPromptText": {
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "20",
    "fontWeight": "400",
    "lineHeight": "24",
    "color": "#616c73"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-fa4d1aea!./~/weex-vue-loader/lib/selector.js?type=styles&index=2!./packages/dof-status/index.vue
// module id = 554
// module chunks = 0 1